import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const certificates = [
  { name: 'CE Belgesi', file: 'CE.pdf' },
  { name: 'ISO 9001', file: 'ISO9001.pdf' },
  { name: 'ISO 9001-77', file: 'ISO9001-77.pdf' },
  { name: 'ISO 10002', file: 'ISO10002.pdf' },
  { name: 'ISO 14001', file: 'ISO14001.pdf' },
  { name: 'ISO 45001', file: 'ISO45001.pdf' },
];

const BASE_URL = 'https://okayisu.com/common/img/belgeler/';

export default function AboutContent() {
  const { t } = useTranslation();

  const statsList = [
    { value: '22+', label: t('stats.yearsExperience'), icon: 'ri-calendar-check-line' },
    { value: '1000+', label: t('stats.completedProjects'), icon: 'ri-building-line' },
    { value: '20', label: t('stats.countriesService'), icon: 'ri-global-line' },
    { value: '%100', label: t('stats.customerSatisfaction'), icon: 'ri-star-line' },
  ];

  const values = [
    { icon: 'ri-lightbulb-flash-line', title: t('aboutPage.values.v1.title'), desc: t('aboutPage.values.v1.desc') },
    { icon: 'ri-shield-check-line', title: t('aboutPage.values.v2.title'), desc: t('aboutPage.values.v2.desc') },
    { icon: 'ri-team-line', title: t('aboutPage.values.v3.title'), desc: t('aboutPage.values.v3.desc') },
    { icon: 'ri-recycle-line', title: t('aboutPage.values.v4.title'), desc: t('aboutPage.values.v4.desc') },
    { icon: 'ri-global-line', title: t('aboutPage.values.v5.title'), desc: t('aboutPage.values.v5.desc') },
    { icon: 'ri-hand-heart-line', title: t('aboutPage.values.v6.title'), desc: t('aboutPage.values.v6.desc') },
  ];

  return (
    <>
      {/* Company Story */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
            <div className="relative order-2 lg:order-1">
              <div className="w-full aspect-[4/3] rounded-3xl overflow-hidden">
                <img
                  src="https://okayisu.com/common/img/site/hakkimizda-img2.jpg"
                  alt="OKAYISU Team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-amber-500 rounded-2xl p-5 text-white hidden md:block" style={{ boxShadow: '0 8px 24px rgba(245,158,11,0.35)' }}>
                <div className="text-3xl font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>22+</div>
                <div className="text-xs font-medium text-white/80 mt-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.story.yearsBadge')}</div>
              </div>
              <div className="absolute -top-4 -left-4 w-16 h-16 border-2 border-amber-200 rounded-2xl hidden md:block" />
            </div>

            <div className="order-1 lg:order-2">
              <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-6">
                <span className="w-1 h-1 bg-amber-500 rounded-full" />
                <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.story.badge')}</span>
              </div>
              <h2 className="text-gray-900 text-3xl md:text-4xl font-bold leading-tight mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {t('aboutPage.story.title')}{' '}
                <span className="text-amber-500">{t('aboutPage.story.accent')}</span>
              </h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.story.p1')}</p>
              <p className="text-gray-500 text-sm leading-relaxed mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.story.p2')}</p>
              <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.story.p3')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white border border-gray-100 rounded-3xl p-8 md:p-10 hover:border-amber-200 transition-all duration-300" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
              <div className="w-12 h-12 flex items-center justify-center bg-amber-50 border border-amber-100 rounded-2xl mb-6">
                <i className="ri-focus-2-line text-amber-500 text-xl" />
              </div>
              <h3 className="text-gray-900 text-xl font-bold mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.mission.title')}</h3>
              <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.mission.p')}</p>
            </div>

            <div className="bg-white border border-gray-100 rounded-3xl p-8 md:p-10 hover:border-amber-200 transition-all duration-300" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
              <div className="w-12 h-12 flex items-center justify-center bg-amber-50 border border-amber-100 rounded-2xl mb-6">
                <i className="ri-eye-line text-amber-500 text-xl" />
              </div>
              <h3 className="text-gray-900 text-xl font-bold mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.vision.title')}</h3>
              <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.vision.p')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-5">
              <span className="w-1 h-1 bg-amber-500 rounded-full" />
              <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.stats.badge')}</span>
            </div>
            <h3 className="text-gray-900 text-2xl md:text-3xl font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('aboutPage.stats.title')}{' '}
              <span className="text-amber-500">{t('aboutPage.stats.accent')}</span>
            </h3>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {statsList.map((stat, idx) => (
              <div key={idx} className="bg-white border border-gray-100 rounded-2xl p-6 text-center hover:border-amber-200 transition-all duration-300" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                <div className="w-11 h-11 flex items-center justify-center mx-auto mb-3 bg-amber-50 rounded-xl">
                  <i className={`${stat.icon} text-amber-500 text-xl`} />
                </div>
                <div className="text-amber-500 text-3xl font-bold mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>{stat.value}</div>
                <div className="text-gray-500 text-xs tracking-wide font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-5">
              <span className="w-1 h-1 bg-amber-500 rounded-full" />
              <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.values.badge')}</span>
            </div>
            <h3 className="text-gray-900 text-2xl md:text-3xl font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('aboutPage.values.title')}{' '}
              <span className="text-amber-500">{t('aboutPage.values.accent')}</span>
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v, idx) => (
              <div key={idx} className="bg-white border border-gray-100 rounded-2xl p-6 hover:border-amber-200 transition-all duration-300 flex items-start gap-4" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                <div className="w-10 h-10 flex items-center justify-center bg-amber-50 border border-amber-100 rounded-xl flex-shrink-0">
                  <i className={`${v.icon} text-amber-500 text-base`} />
                </div>
                <div>
                  <h4 className="text-gray-900 text-sm font-bold mb-1.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>{v.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certificates */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-5">
              <span className="w-1 h-1 bg-amber-500 rounded-full" />
              <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.certificates.badge')}</span>
            </div>
            <h3 className="text-gray-900 text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.certificates.title')}</h3>
            <p className="text-gray-500 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.certificates.desc')}</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {certificates.map((cert, idx) => (
              <a key={idx} href={`${BASE_URL}${cert.file}`} target="_blank" rel="noopener noreferrer" className="group bg-white border border-gray-100 rounded-xl p-5 flex flex-col items-center gap-3 hover:border-amber-300 hover:bg-amber-50/50 transition-all duration-300 cursor-pointer" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-lg group-hover:bg-red-100 transition-colors duration-300">
                  <i className="ri-file-pdf-line text-red-500 text-xl" />
                </div>
                <span className="text-gray-700 text-xs font-semibold text-center leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>{cert.name}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-6">
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('aboutPage.cta.badge')}</span>
          </div>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-bold leading-tight mb-5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('aboutPage.cta.title')}{' '}
            <span className="text-amber-500">{t('aboutPage.cta.accent')}</span>
          </h2>
          <p className="text-gray-500 text-sm max-w-lg mx-auto mb-8 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t('aboutPage.cta.desc')}</p>
          <Link
            to="/iletisim"
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-bold px-8 py-3.5 rounded-full text-sm tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {t('aboutPage.cta.btn')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </>
  );
}